import { useNavigate } from 'react-router-dom';

export function SharedLinkLoading() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4">
        <div
          style={{ width: 24, height: 24, cursor: 'pointer' }}
          onClick={() => navigate('/')}
        >
          <img
            src="/assets/logo-rebranding-syncly.svg"
            width="100%"
            height="100%"
            alt="Syncly"
          />
        </div>
        <p className="text-gray-500">Loading...</p>
      </div>
    </div>
  );
}
